'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const BreadcrumbsItem = forwardRef(function BreadcrumbsItem({ className, ...rest }, ref) {
    return jsx("li", { ref: ref, ...rest });
});

export { BreadcrumbsItem };
